// src/pages/RespondPage.js
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import API_URL from '../config';
import './RespondPage.css';

function RespondPage() {
    const { groupId, participantId } = useParams();
    const [status, setStatus] = useState('');
    const [loading, setLoading] = useState(false);
    const [groupData, setGroupData] = useState(null);
    const [participantData, setParticipantData] = useState(null);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (!groupId || !participantId) {
            setStatus('Fel: Grupp- eller deltagar-ID saknas i URL:en.');
            return;
        }

        const fetchGroupAndParticipant = async () => {
            try {
                // ✅ FIX 1: Use public endpoint - no auth required
                const response = await axios.get(`${API_URL}/api/public/respond/${groupId}/${participantId}`);
                setGroupData(response.data.group);
                setParticipantData(response.data.participant);
            } catch (error) {
                console.error('Kunde inte hämta gruppdata:', error);
                setStatus('Fel: Kunde inte ladda gruppinformation.');
            }
        };

        fetchGroupAndParticipant();
    }, [groupId, participantId]);

    const handleResponse = async (answer) => {
        if (!groupId || !participantId || loading) {
            return;
        }

        setLoading(true);
        setStatus(`Skickar ditt svar: "${answer}"...`);

        try {
            // ✅ FIX 2: Use public endpoint - correct URL
            const response = await axios.post(
                `${API_URL}/api/public/respond/${groupId}/${participantId}`,
                { answer }
            );
            setStatus(response.data.message);
        } catch (error) {
            console.error('Kunde inte skicka svar:', error);
            setStatus(`Kunde inte registrera ditt svar. ${error.response?.data?.message || error.message}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="respond-page">
            <div className="respond-container">
                {groupData && participantData ? (
                    <>
                        <h1>Hej {participantData.name}!</h1>
                        <h2>Svar på inbjudan till: {groupData.groupName}</h2>
                        
                        {groupData.meetingFrequency?.dayOfWeek && (
                            <p className="meeting-info">
                                Möte: {groupData.meetingFrequency.dayOfWeek}ar kl {groupData.meetingFrequency.time}
                                {groupData.location && ` på ${groupData.location}`}
                            </p>
                        )}

                        <div className="response-buttons">
                            <button 
                                className="btn-yes" 
                                onClick={() => handleResponse('Ja')}
                                disabled={loading}
                            >
                                ✅ Ja, jag kommer
                            </button>
                            <button 
                                className="btn-no" 
                                onClick={() => handleResponse('Nej')}
                                disabled={loading}
                            >
                                ❌ Nej, jag kan inte
                            </button>
                        </div>

                        {status && (
                            <div className={`status-message ${status.includes('Fel') ? 'error' : 'success'}`}>
                                {status}
                            </div>
                        )}
                    </>
                ) : (
                    <div className="loading">
                        {status || 'Laddar...'}
                    </div>
                )}
            </div>
        </div>
    );
}

export default RespondPage;
